import React from 'react';

export default function Loader({ load=false }) {
  return (
    <div className={ `loader${ load ? ' active' : '' }` }><span></span></div>
  )
}
